const TABLES_URL = '/financial/towerStages'

export default {
    state: {
        tables: []
    },
    mutations: {
        _setTables(state, tables){
            state.tables = tables
        }
    },
    getters: {
        getTables: (state) =>{
            return state.tables
        }
    },
    actions: {
       async getAvailableTables(context, development){
            const AVAILABLE_LOCATION_URL = `${TABLES_URL}/?projectId=${development.id}`;
            let response = await context.rootGetters.apiClub.get(`${AVAILABLE_LOCATION_URL}`);   
            context.commit('_setTables', response.data)
        }
    }
}